import {
    ITpayPayload,
    ITpayRedirectSubscribeExistingUserEntity,
    ITpayRedirectSubscribeExistingUserReqBody,
} from '../../../entity/interface/iTPayRedirectSubscribe';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { container } from '../../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';

export interface ITpayRedirectSubscribeExistingUseCase {
    execute(
        username: string,
        msisdn: string,
        tpay: ITpayPayload,
        reqBody: ITpayRedirectSubscribeExistingUserReqBody
    ): Promise<ITpayRedirectSubscribeExistingUserEntity>;
}
export class TpayRedirectSubscribeExistingUseCase implements ITpayRedirectSubscribeExistingUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        username: string,
        msisdn: string,
        tpay: ITpayPayload,
        reqBody: ITpayRedirectSubscribeExistingUserReqBody
    ): Promise<ITpayRedirectSubscribeExistingUserEntity> {
        return await this.subscriptionRepository.tpayRedirectSubscribeExisting(username, msisdn, tpay, reqBody);
    }
}
